module.exports = __webpack_public_path__ + "static/media/nano.20737f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/wallets/nano.png
// module id = 70
// module chunks = 0